import { cn } from "@devhop/ui";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

type OrderDetailSectionProps = {
  title?: string;
  description?: string;
  icon?: LucideIcon;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  variant?: "default" | "muted";
};

export function OrderDetailSection({
  title,
  description,
  icon: Icon,
  action,
  children,
  className,
  contentClassName,
  variant = "default",
}: OrderDetailSectionProps) {
  return (
    <section
      className={cn(
        "overflow-hidden rounded-xl border bg-card shadow-sm",
        variant === "muted" && "bg-muted/20",
        className,
      )}
    >
      {(title || action) && (
        <div className="flex items-start justify-between gap-3 border-b bg-muted/30 px-4 py-3">
          <div className="min-w-0">
            {title && (
              <h2 className="flex items-center gap-2 font-semibold text-base">
                {Icon && <Icon className="h-4 w-4 text-primary" />}
                {title}
              </h2>
            )}
            {description && (
              <p className="mt-0.5 text-muted-foreground text-sm">
                {description}
              </p>
            )}
          </div>
          {action}
        </div>
      )}
      <div className={cn("p-4", contentClassName)}>{children}</div>
    </section>
  );
}
